import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    //desc: "退出登录",
    method: "post",
    name: "logout",
    url: "/account/logout",
  },
  {
    method: "postExFile",
    name: "exportSourcePPT",
    url: "/activity/contribute/exportSourcePPT", // 下载-源文件
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
